import { PaymentMethod, PaypalPaymentBody, TipaltiPaymentBody } from '@round/api';
import * as Yup from 'yup';
import { PaymentRequestFormValues, ScheduledDate } from './components/PostPaymentRequestForm';

export const validationSchema = Yup.object().shape({
    amount: Yup.string().required('Amount is required'),
    currency: Yup.object().nullable().required('Currency is required'),
    payment_method: Yup.string().required('Payment method is required'),
    tipalti_payee_id: Yup.number().when('payment_method', {
        is: (paymentMethod: PaymentMethod) => paymentMethod === 'tipalti',
        then: (schema) => schema.required('Tipalti payee ID is required'),
    }),
    paypal_email_address: Yup.string().when('payment_method', {
        is: (paymentMethod: PaymentMethod) => paymentMethod === 'paypal',
        then: (schema) => schema.email('Must be a valid email address').required('PayPal email address is required'),
    }),
    tipalti_scheduled_datetime: Yup.string().when(['scheduledDate', 'payment_method'], {
        is: (scheduledDate: ScheduledDate, payment_method: string) =>
            scheduledDate !== 'immediate' && payment_method === 'tipalti',
        then: (schema) => schema.required('Please select a date'),
        otherwise: (schema) => schema.optional().notRequired(),
    }),
});

export const getThirtyDaysDateStringValue = () =>
    new Date(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).setUTCHours(0, 0, 0, 0)).toISOString();

export const baseInitialValues: Pick<
    PaymentRequestFormValues,
    'tipalti_payee_id' | 'tipalti_scheduled_datetime' | 'payment_method' | 'scheduledDate'
> = {
    tipalti_payee_id: undefined,
    payment_method: 'paypal',
    scheduledDate: '30days',
    tipalti_scheduled_datetime: getThirtyDaysDateStringValue(),
};

export const getPaymentMethodAPIValues = (
    values: PaymentRequestFormValues
): (PaypalPaymentBody & { payment_method: 'paypal' }) | (TipaltiPaymentBody & { payment_method: 'tipalti' }) => {
    if (values.payment_method === 'tipalti') {
        if (typeof values.tipalti_payee_id !== 'number') {
            throw new Error('Tipalti payee ID is missing');
        }

        return {
            payment_method: 'tipalti',
            tipalti_payee_id: values.tipalti_payee_id,
            tipalti_scheduled_datetime: values.tipalti_scheduled_datetime,
        };
    }

    if (!values.paypal_email_address) {
        throw new Error('PayPal email address is missing');
    }

    return {
        payment_method: 'paypal',
        paypal_email_address: values.paypal_email_address,
    };
};
